/** Encode browser-generated CSV without losing text or changing record boundaries. */
export const encodeCsvField = (value: unknown): string => {
  const text = value == null ? '' : String(value);
  return /[,"\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
};

export const buildCsv = (rows: readonly (readonly unknown[])[]): string =>
  rows.map(row => row.map(encodeCsvField).join(',')).join('\n');
